import Model from './Model'
import moment from "moment";
import {uuid} from "../utils";

export default class RoutePlan extends Model {

    async acquireEditLock(connectionId) {
        return await Http.put(route('api.v2.logistics.route-plans.acquire-edit-lock', [this.id]),{connectionId})
    }
    async releaseEditLock() {
        return await Http.put(route('api.v2.logistics.route-plans.release-edit-lock', [this.id]))
    }

    async reload() {
        let o = await RoutePlan.find(this.id)
        Object.assign(this, o)
    }

    getDownloadUrl() {
        return route('api.v2.logistics.route-plans.pdf', this.id)
    }
    getPrintableUrl() {
        return route('api.v2.logistics.route-plans.print', this.id)
    }

    getFormAttributes() {
        return this.only(['date', 'vehicleRegistration', 'driver', 'jobs'])
    }
    setAttributes(attributes) {
        super.setAttributes(attributes);
        let date = moment(attributes.date)
        this.formatted_date = date.format('DD/MM/YYYY')
        this.jobs.sort(function (a, b) {
            return a.order - b.order
        });
        let tokens = [
            attributes.vehicleRegistration,
            attributes.driver,
            this.formatted_date,
        ]
        this.jobs.forEach((job) => {
            tokens.push(job.address, job.contact, job.materials);
        })
        this.tokens = tokens.join('|').toLowerCase();
    }

    async send(attributes = {}) {
        const url = route("api.v2.logistics.route-plans.send", [this.id]);
        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        Object.assign(this, await RoutePlan.find(this.id));
        return success;
    }

    async revoke(sendRequestId) {
        const url = route('api.v2.logistics.route-plans.revoke', [this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        Object.assign(this, await RoutePlan.find(this.id));
        return success;
    }

    async resend(sendRequestId) {
        const url = route('api.v2.logistics.route-plans.revoke', [this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        Object.assign(this, await RoutePlan.find(this.id));
        return success;
    }
    static parseAttributes(attributes = {}) {
        attributes = this.parseDropdownAttributes(attributes, ['package_id']);
        attributes.items = (attributes.items || []).map(item => `${item.id}_${item.quantity}`)

        return attributes
    }

    static async all() {
        const config = {params: {}}
        const data = await Http.get(route('api.v2.logistics.route-plans.list'), config)
        return this.make(data)
    }

    static async find(id) {
        const data = await Http.get(route('api.v2.logistics.route-plans', id))
        return this.make(data)
    }

    static async create(attributes) {
        const id = uuid();
        await Http.post(route('api.v2.logistics.route-plans.store', id), this.parseAttributes(attributes))
        const data = await Http.get(route('api.v2.logistics.route-plans', id))
        return this.make(data)
    }

    async delete() {
        await Http.delete(route('api.v2.logistics.route-plans.delete', this.id))
    }

    async update(attributes = {}) {
        const url = route('api.v2.logistics.route-plans.store', this.id)
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        await Http.put(url, payload)
        const data = await Http.get(route('api.v2.logistics.route-plans', this.id))
        return this.fill(data)
    }

    async completeJob(job) {
        const url = route('api.v2.logistics.route-plans.jobs.complete', [this.id, job.id])
        await Http.put(url)
        const data = await Http.get(route('api.v2.logistics.route-plans', this.id))
        return this.fill(data)
    }

    async completeAllJobs() {
        await Promise.all(this.jobs.map(async (job) => {
            const url = route('api.v2.logistics.route-plans.jobs.complete', [this.id, job.id])
            await Http.put(url)
        }));
        const data = await Http.get(route('api.v2.logistics.route-plans', this.id))
        return this.fill(data)
    }

    async failJob(job) {
        const url = route('api.v2.logistics.route-plans.jobs.fail', [this.id, job.id])
        await Http.put(url)
        const data = await Http.get(route('api.v2.logistics.route-plans', this.id))
        return this.fill(data)
    }

    async resetJob(job) {
        const url = route('api.v2.logistics.route-plans.jobs.reset', [this.id, job.id])
        await Http.put(url)
        const data = await Http.get(route('api.v2.logistics.route-plans', this.id))
        return this.fill(data)
    }

    isInPast() {
        let date = new Date(this.date);
        let now = new Date();
        return date <= now;
    }
}
